<section class="settlements-page">
  <header class="settlements-toolbar">
    <div>
      <h1>Взаиморасчеты</h1>
      <span>Доходы, затраты и переводы между участниками событий.</span>
    </div>
    <div class="toolbar-actions">
      <label class="month-control"><span>Период</span><input type="month" [(ngModel)]="month" (ngModelChange)="onMonthChange()"></label>
      <button class="action-button primary" type="button" [disabled]="!preview?.isReadyToSettle || closing" (click)="closePeriod()">{{ closing ? 'Фиксируем...' : 'Рассчитались' }}</button>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="warning-panel" *ngIf="preview?.warnings?.length">
    <strong>{{ preview.status === 'settled' ? 'Период зафиксирован' : 'Что нужно заполнить перед закрытием' }}</strong>
    <ul><li *ngFor="let warning of preview.warnings">{{ warning }}</li></ul>
  </section>

  <section class="metrics" *ngIf="preview">
    <article><span>Оплаченная выручка</span><strong>{{ formatMoney(revenueTotal) }}</strong></article>
    <article><span>Все затраты</span><strong>{{ formatMoney(costTotal) }}</strong></article>
    <article><span>Чистая прибыль</span><strong [class.negative]="profitTotal < 0">{{ formatMoney(profitTotal) }}</strong></article>
    <article><span>Событий в периоде</span><strong>{{ preview.events.length }}</strong></article>
  </section>

  <section class="balance-overview" *ngIf="participantBalances.length">
    <header>
      <div>
        <h2>Итог по участникам</h2>
        <span>Сначала закрываем расходы, затем делим чистую прибыль.</span>
      </div>
    </header>
    <div class="balance-grid">
      <article
        class="balance-card"
        *ngFor="let balance of participantBalances; trackBy: trackById"
        [class.debtor]="balance.netBalance > 0"
        [class.creditor]="balance.netBalance < 0">
        <div class="balance-card-heading">
          <strong>{{ balance.username }}</strong>
          <span>{{ getSettlementActionLabel(balance) }}</span>
        </div>
        <b [class.debtor-text]="balance.netBalance > 0" [class.creditor-text]="balance.netBalance < 0">{{ formatMoney(getSettlementActionAmount(balance)) }}</b>
        <dl>
          <div><dt>Принято оплат</dt><dd>{{ formatMoney(balance.salesReceived) }}</dd></div>
          <div><dt>Понес расходов</dt><dd>{{ formatMoney(balance.reimbursementTotal) }}</dd></div>
          <div><dt>После расходов</dt><dd [class.positive]="balance.afterExpenses >= 0" [class.negative]="balance.afterExpenses < 0">{{ formatMoney(balance.afterExpenses) }}</dd></div>
          <div><dt>Доля прибыли</dt><dd>{{ formatMoney(balance.profitShareAmount) }}</dd></div>
        </dl>
      </article>
    </div>
  </section>

  <section class="data-panel" *ngIf="preview?.events?.length; else emptyState">
    <header><h2>События периода</h2><span>{{ formatMonth(month) }}</span></header>
    <div class="table-wrap">
      <table>
        <thead><tr><th>Событие</th><th>Выручка</th><th>Закупка</th><th>Расходы</th><th>Прибыль</th></tr></thead>
        <tbody>
          <tr *ngFor="let event of preview.events; trackBy: trackById">
            <td><strong>{{ event.eventName }}</strong></td><td>{{ formatMoney(event.revenue) }}</td><td>{{ formatMoney(event.purchaseTotal) }}</td>
            <td>{{ formatMoney(event.directExpenseTotal + event.monthlyExpenseTotal) }}</td><td [class.negative]="event.netProfit < 0"><strong>{{ formatMoney(event.netProfit) }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="data-panel" *ngIf="preview?.lines?.length">
    <header><h2>Детализация балансов</h2><span>Положительный итог переводится, отрицательный участник получает.</span></header>
    <div class="table-wrap">
      <table>
        <thead><tr><th>Участник</th><th>Событие</th><th>Принято оплат</th><th>Понес расходов</th><th>После расходов</th><th>Доля прибыли</th><th>Итог</th></tr></thead>
        <tbody>
          <tr *ngFor="let line of preview.lines; trackBy: trackById">
            <td><strong>{{ line.username }}</strong></td><td>{{ line.eventName }}</td><td><strong>{{ formatMoney(line.salesReceived) }}</strong></td>
            <td>
              <div class="money-breakdown">
                <strong>{{ formatMoney(getReimbursementTotal(line)) }}</strong>
                <small>Закупка: {{ formatMoney(line.ticketPurchaseReimbursement) }}</small>
                <small>Расходы: {{ formatMoney(line.directExpenseReimbursement) }}</small>
                <small>Месяц: {{ formatMoney(line.monthlyExpenseReimbursement) }}</small>
              </div>
            </td>
            <td [class.positive]="getAfterExpenses(line) >= 0" [class.negative]="getAfterExpenses(line) < 0"><strong>{{ formatMoney(getAfterExpenses(line)) }}</strong></td>
            <td>{{ formatMoney(line.profitShareAmount) }} <small>({{ line.profitShareBasisPoints / 100 }}%)</small></td>
            <td [class.debtor-text]="line.netBalance > 0" [class.creditor-text]="line.netBalance < 0">
              <div class="money-breakdown action">
                <strong>{{ getSettlementActionLabel(line) }}</strong>
                <small>{{ formatMoney(getSettlementActionAmount(line)) }}</small>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="data-panel transfers" *ngIf="preview?.suggestedTransfers?.length">
    <header><h2>{{ preview.status === 'settled' ? 'Зафиксированные переводы' : 'Кому перевести' }}</h2></header>
    <div class="transfer-list">
      <div *ngFor="let transfer of preview.suggestedTransfers"><strong>{{ transfer.fromUsername }}</strong><span>переводит</span><strong>{{ transfer.toUsername }}</strong><b>{{ formatMoney(transfer.amount) }}</b></div>
    </div>
  </section>

  <section class="history" *ngIf="periods.length">
    <span>Закрытые периоды:</span><button type="button" *ngFor="let period of periods" [class.active]="period.month === month" (click)="month = period.month; onMonthChange()">{{ formatMonth(period.month) }}</button>
  </section>

  <ng-template #emptyState><section class="empty-state"><h2>{{ loading ? 'Считаем взаиморасчеты...' : 'Нет данных для взаиморасчетов' }}</h2><p *ngIf="!loading">В расчет входят только события со статусом «В работе» или «Завершен».</p></section></ng-template>
</section>
